import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectCityField, {
  MxFormSelectCityFieldProp
} from "@rf-l2/form/select/MxFormSelectCityField";

export interface MxFormL3CityFieldProps extends MxFormSelectCityFieldProp {
  name: string;
  withreacthookform?:1|0;
}
const MxFormL3CityField = (props: MxFormL3CityFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectCityField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3CityField;
